import RegisterRequestModelBase from '../_generated/modelBases/register-request-model-base';

export default class RegisterRequestModel extends RegisterRequestModelBase {
  public repeatPassword?: string;
}
